import {
    AGENTS_UPDATED,
    BDS_UPDATED,
    CLIENTS_UPDATED,
    CUSTODIANS_UPDATED,
    GET_AGENTS_ERROR,
    GET_BDS_ERROR,
    GET_CLIENTS_ERROR,
    GET_CUSTODIANS_ERROR,
    GET_GROUPS_ERROR,
    GET_RIAS_ERROR,
    GROUPS_UPDATED,
    RIAS_UPDATED
} from "./actionTypes";

const initialState = {
    custodians: [],
    bds: [],
    rias: [],
    agents: [],
    clients: [],
    groups: []
};

const info = (state = initialState, action) => {
    switch (action.type) {
        case CUSTODIANS_UPDATED:
            state = {
                ...state,
                custodians: action.payload || []
            };
            break;

        case GET_CUSTODIANS_ERROR:
            state = {
                ...state,
                custodians: []
            };
            break;

        case BDS_UPDATED:
            state = {
                ...state,
                bds: action.payload || []
            };
            break;

        case GET_BDS_ERROR:
            state = {
                ...state,
                bds: []
            };
            break;

        case RIAS_UPDATED:
            state = {
                ...state,
                rias: action.payload || []
            };
            break;

        case GET_RIAS_ERROR:
            state = {
                ...state,
                rias: []
            };
            break;

        case AGENTS_UPDATED:
            state = {
                ...state,
                agents: action.payload || []
            };
            break;

        case GET_AGENTS_ERROR:
            state = {
                ...state,
                agents: []
            };
            break;

        case CLIENTS_UPDATED:
            state = {
                ...state,
                clients: action.payload || []
            };
            break;

        case GET_CLIENTS_ERROR:
            state = {
                ...state,
                clients: []
            };
            break;

        case GROUPS_UPDATED:
            state = {
                ...state,
                groups: action.payload || []
            };
            break;

        case GET_GROUPS_ERROR:
            state = {
                ...state,
                groups: []
            };
            break;

        default:
            state = {...state};
            break;
    }
    return state;
};

export default info;
